import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class UserTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Benutzer Einstellungen" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Admin Name', descriptionColumn: 'Das ist der Name und das Kennwort des Administrator Logins. Der Administrator hat Zugriff auf alle Funktionen der Kamera. Der Standard ist admin/instar.' },
        { actionColumn: 'Benutzer Name', descriptionColumn: ' Das ist der Name und das Kennwort des normalen Benutzerlogins. Der Benutzer hat Zugriff auf den Videostream und kann außerdem die Kamera Schwenken & Neigen (nur PTZ Kameras). Das Konfigurationsmenü ist nicht verfügbar. Der Standard ist user/instar.' },
        { actionColumn: 'Gast Name', descriptionColumn: 'Das ist der Name und das Kennwort des normalen Gastlogins. Der Gast hat nur Zugriff auf den Videostream. Der Standard ist guest/instar.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

UserTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(UserTable)